module.exports = __webpack_public_path__ + "static/media/main-energy-bar.db688f5a.png";